module.exports = __webpack_public_path__ + "../resources/img/ic_unlinked_gray100.76e7c299.svg";